import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function EducationStatsChart({ stats }) {
  // Example chart: visualize all four stats as bars
  const data = {
    labels: [
      "Participants",
      "Quizzes Completed",
      "Avg. Score",
      "Highest Score"
    ],
    datasets: [
      {
        label: "Education Stats",
        data: [
          stats.total_users,
          stats.total_completed_quizzes,
          stats.average_score,
          stats.highest_score
        ],
        backgroundColor: [
          "#e11d2e", // accent -- matches --accent
          "#3fae6a", // matches --success
          "#ff4757", // matches --link
          "#d99a3d"  // matches --warning
        ],
        borderRadius: 8,
        maxBarThickness: 48
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: false }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { color: "#c9c9c9" }, // matches --text-2
        grid: { color: "rgba(255,255,255,0.10)" } // matches --border
      },
      x: {
        ticks: { color: "#c9c9c9" }, // matches --text-2
        grid: { color: "rgba(255,255,255,0.10)" } // matches --border
      }
    }
  };

  return (
    <div className="panel" style={{ padding: 'var(--sp-5)' }}>
      <h3 style={{ fontSize: 14.5, fontWeight: 700, marginBottom: 'var(--sp-4)', color: 'var(--text-1)' }}>Education Overview</h3>
      <div
        role="img"
        aria-label={`Bar chart of education statistics: ${stats.total_users} participants, ${stats.total_completed_quizzes} quizzes completed, average score ${stats.average_score}, highest score ${stats.highest_score}.`}
      >
        <Bar data={data} options={options} height={220} />
      </div>
    </div>
  );
}
